import React, { useState } from 'react'
import LockKeySVG from 'images/forgot-pw.svg'

import { sendResetPasswordEmail } from 'services/user'

import './ForgotPasswordModal.scss'

const ForgotPasswordModal = ({ closeModal }) => {
  const [resetEmailSent, setResetEmailSent] = useState(false)
  const [serverError, setServerError] = useState(false)
  const [buttonReady, setButtonReady] = useState(false)

  const handleSubmit = async e => {
    e.preventDefault()
    const emailValue = document.forms['forgot-pw']['email'].value
    try {
      const response = await sendResetPasswordEmail(emailValue)
      //console.log('resetpw sent ',response)
      setResetEmailSent(true)
    } catch (e) {
      //console.log('resetpw error: ',e)
      setServerError(true)
    }
  }

  const onInputChange = e => {
    if (e.target && e.target.value.length > 0) {
      setButtonReady(true)
    } else {
      setButtonReady(false)
    }
  }

  return (
    <div className={`modal-forgot button-ready-${buttonReady}`}>
      <button
        className={`modal-close`}
        onClick={closeModal}
        aria-label="Next"
      ></button>
      <img className="header-image" src={LockKeySVG} alt="" />
      {!resetEmailSent && (
        <>
          <h1>Forgot Password</h1>
          <p>
            Enter the email address associated with this account and we’ll send
            you a link to reset your password.
          </p>
          <form onSubmit={handleSubmit} name="forgot-pw">
            <div className="input-container">
              <input
                type="text"
                className={serverError ? 'invalid' : ''}
                placeholder="Enter your email"
                name="email"
                onChange={onInputChange}
              />
              {serverError && (
                <span className="server-error">User not found.</span>
              )}
            </div>
            <input type="submit" value="Send Reset Link" />
          </form>
        </>
      )}
      {resetEmailSent && (
        <>
          <h1>Sent!</h1>
          <p>
            Thanks! We've sent you an email with a link to reset your password.
          </p>
        </>
      )}
    </div>
  )
}

export default ForgotPasswordModal
